<template>
  <div>
    <div>
      <div class="take-over-toolbar" v-if="isShowActiveEditingUser && isDisableEditPresentation">
        <div
          v-if="currentUser
            && currentUser.accountRole === workspace.VIEWER
            && !isShareWithMePresentation"
          class="take-over--editor-info"
        >
          <div
            class="border-left"
            :class="{
              'bg-yellow-50': isDisableEditPresentation,
              'bg-primary-90': !isDisableEditPresentation
            }"
          ></div>
          <aha-avatar
            class="take-over--avatar"
            :name="currentUser.firstName"
            :image="currentUser.avatar"
            :id="currentUser.id"
          />
          <p class="take-over--editor-text">
            {{ $i18nPresenter.t('You can only view this presentation.') }}
          </p>
          <a
            class="font-bold text-link--primary"
            @click="reloadPage"
            v-tooltip="$i18nPresenter.t('Refresh to view the latest version')"
          >
            {{ $i18nPresenter.t('Refresh') }}</a>
        </div>
        <div
          v-else
          class="take-over--editor-info"
        >
          <div
            class="border-left"
            :class="{
              'bg-yellow-50': isDisableEditPresentation,
              'bg-primary-90': !isDisableEditPresentation
            }"
          ></div>
          <!-- <aha-avatar
            class="take-over--avatar"
            :name="presentation.TakenOverByUser.firstName"
            :image="presentation.TakenOverByUser.avatar"
            :id="presentation.TakenOverByUser.id"
          /> -->
          <!-- <p
            class="take-over--editor-text"
            v-html="$i18nPresenter.t('xxxIsEditingYouCanOnlyViewIt', {
              name: presentation.TakenOverByUser.name,
              email: presentation.TakenOverByUser.email
            })"
          >
          </p> -->
          <p class="take-over--editor-text">
            To edit or present, please take over from <b>{{ presentation.TakenOverByUser.email }}</b>
          </p>
        </div>
        <div
          v-if="!(currentUser && currentUser.accountRole === workspace.VIEWER
            && !isShareWithMePresentation)"
          class="take-over--actions"
        >
          <aha-button
            variant="base"
            class="mr-4 -mt-1 bg-secondary-10"
            @click="openTakeOverModal()"
          >
            {{ $i18nPresenter.t('Take over') }}
          </aha-button>
          <a
            class="font-bold text-link--primary"
            @click="reloadPage"
            v-tooltip="$i18nPresenter.t('Refresh to view the latest version')"
          >
            {{ $i18nPresenter.t('Refresh') }}
          </a>
        </div>
      </div>
    </div>
    <TakeOverModal
      v-if="isShowTakeOverModal"
      :submitting="submitting"
      :presenting="presentation.presenting"
      @hide="closeTakeOverModal"
      @takeOver="takeover()"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import PresentationApi from '@/api/presentation'
import TakeOverModal from '@/components-v2/presentation-editor/collaboration/TakeOverModal.vue'

// utils
import Utils from '@/util'

import constants from '@/constant'

export default {
  components: {
    TakeOverModal,
  },
  data() {
    return {
      submitting: false,
      isShowTakeOverModal: false,
      permissions: constants.permissions,
      workspace: constants.workspace,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapState({
      presentation: (state) => state.presentation,
      presentationEditors: (state) => state.presentationEditors,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      currentUser: (state) => state.currentUser,
    }),
    isShareWithMePresentation() {
      return !this.presentation.accountId
    },
    isShowActiveEditingUser() {
      if (this.isBackstage) return false
      return (this.presentation.TakenOverByUser &&
        this.presentation.TakenOverByUser.id !== this.currentUser.id)
        || (this.presentationEditors.length > 1)
    },
    showNoteCanEditThisSlide() {
      return this.presentationEditors.length > 1 ||
        (this.presentationEditors.length === 1 &&
        this.presentationEditors[0].id !== this.presentation.takenOverBy)
    },
  },
  methods: {
    openTakeOverModal() {
      this.isShowTakeOverModal = true
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Open Modal')
    },
    closeTakeOverModal() {
      this.isShowTakeOverModal = false
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Close Modal')
    },
    async takeover() {
      this.submitting = true
      try {
        await PresentationApi.takeOver(this.presentation.id)
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Succeeded')
      } catch (e) {
        if (e.status === 403) window.location.reload()
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Failed')
      }

      // Looks dumb, I know. Wait 1s to synchronize with socket message to update UI properly
      setTimeout(() => {
        this.submitting = false
        this.isShowTakeOverModal = false
      }, 1000)
    },
    reloadPage() {
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Refresh')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
.take-over-toolbar {
  @apply border-b border-base-30 bg-base-0 relative flex items-center flex-grow-0 flex-shrink-0;
  width: 100%;
  padding: 12px 16px 11px;

  &.p-0 {
    padding: 0;
  }
}

.take-over--editor-info {
  @apply flex flex-row items-center flex-grow;
  padding-left: 5px;
  padding-right: 10px;
  width: 0;
}
.border-left {
  width: 5px;
  height: 28px;
  border-radius: 6px;
  margin-right: 6px;
}
.take-over--avatar {
  @apply flex-grow-0 flex-shrink-0;
}
.take-over--editor-text {
  @apply pl-2 mx-1;
  width: 100%;
  word-break: break-word;
  margin-left: 0;
  padding-left: 4px;
  &.can-only-view{
    margin-left: 4px;
  }
}
.take-over--actions {
  @apply flex flex-row items-center mr-1;
}

@media (max-width: 525px) {
  .take-over-toolbar.take-over {
    display: block;
  }
  .take-over--editor-info {
    width: 100%;
    align-items: start;
  }
  .take-over--editor-text {
    @apply flex-grow;
    width: 0;
    margin-bottom: 14px;
  }
}
svg.icon-reload.path-fill-current.inline-block{
  &::v-deep{
    path {
      fill: rgba(180, 188, 207, 1);
    }
  }
  &:hover{
    &::v-deep{
      path {
        fill: rgba(52, 142, 246, 1);
      }
    }
  }
}

</style>
